import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges} from '@angular/core';
import {IonicModule, SearchbarCustomEvent} from "@ionic/angular";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule
  ],
  selector: 'app-searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.scss'],
})
export class SearchableSelectComponent  implements OnChanges {
  @Input() title: string = 'N/A'
  @Input() theme: string = ''
  @Input() data: any[]
  @Input() multiple = false
  @Input() itemTextField = 'name'
  @Input() itemTextField2 = ''
  @Input() placeholderText = ''
  isOpen = false
  selected = []
  filtered = []
  @Output() selectedChanged: EventEmitter<any> = new EventEmitter()
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.filtered = this.data
  }

  open(){
    this.isOpen = false
    setTimeout(() => {
      this.isOpen = true
    }, 1);

  }

  cancel() {
    this.isOpen=false
  }

  sajat(){
    this.selectedChanged.emit("saját")
    this.filtered = this.data
    this.selected = []
    this.isOpen=false
  }

  select(){
    const selected = this.data.filter((item) => item.selected)
    this.selected = selected
    this.selectedChanged.emit(this.selected)
    this.isOpen=false
  }

  filter(e: SearchbarCustomEvent){
    const filter = e.detail.value.toLowerCase()
    if(!this.itemTextField2)
    this.filtered = this.data.filter(item => item[this.itemTextField].toString().toLowerCase().indexOf(filter) !== -1)
    else
      this.filtered = this.data.filter(item => item[this.itemTextField].toString().toLowerCase().indexOf(filter) !== -1 || item[this.itemTextField2].toString().toLowerCase().indexOf(filter) !== -1)
  }

  itemSelected(){
    this.selected = this.data.filter((item) => item.selected)

    if(!this.multiple && this.selected.length){
      this.selectedChanged.emit(this.selected)
      this.isOpen=false
      this.filtered = this.data
      this.data.map(item => item.selected=false)
    }
  }

}
